document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.getAttribute('data-qty'));
      if (!input) return;
      var next = parseInt(input.value || '1', 10) + (btn.dataset.dir === 'down' ? -1 : 1);
      input.value = Math.max(1, next);
    });
  });
});
